import { PurchaseOrderStatusChangedEvent } from '@rematter/frontend-lib-api-client/grpc/trade/purchase_order_events_pb';
import { PurchaseOrderStatus } from '@rematter/frontend-lib-api-client/grpc/trade/purchase_order_pb';
import { Col, FieldDisplay, IDField, StatusTransition } from '@rematter/ui-web';

import { purchaseOrderStatusLabels } from '../enumLabels';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

type PurchaseOrderStatusChangedDetailProps = {
  event: PurchaseOrderStatusChangedEvent;
};

export const PurchaseOrderStatusChangedDetail = ({
  event,
}: PurchaseOrderStatusChangedDetailProps) => {
  const t = useTranslations();
  const purchaseOrder = event.purchaseOrder;

  if (!purchaseOrder) {
    return (
      <Col className="@PurchaseOrderStatusChangedDetail items-center justify-center p-4 text-neutral/40">
        <span>{t.eventLogs.noDataAvailable}</span>
      </Col>
    );
  }

  return (
    <Col className="@PurchaseOrderStatusChangedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          {t.eventLogs.purchaseOrder.sectionTitle}
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={purchaseOrder.id?.value} />
          <FieldDisplay
            label={t.eventLogs.purchaseOrder.documentNumber}
            value={purchaseOrder.documentNumber}
          />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          {t.eventLogs.purchaseOrder.statusChange}
        </span>
        <StatusTransition
          previousStatus={
            purchaseOrderStatusLabels[
              event.previousStatus as PurchaseOrderStatus
            ] ?? `Unknown (${event.previousStatus})`
          }
          newStatus={
            purchaseOrderStatusLabels[event.newStatus as PurchaseOrderStatus] ??
            `Unknown (${event.newStatus})`
          }
        />
      </Col>
    </Col>
  );
};
